import { CF } from '@dadohr/shared/versions';

import { useFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import { ONE_MINUTE } from '../../../../../../services/time';

export const useGroupList = (orgId: string) => {
  return useFirebaseFunction<
    {
      id: string;
      name: string;
    }[]
  >(CF.microsoft.groups.getGroupList, { orgId }, [orgId], ONE_MINUTE * 5);
};
